<template>
  <BaseModal
    :heading="$t('register.attach_note')"
    small
    @close="$emit('close')"
  >
    <BaseGrid container>
      <BaseGrid :size="12">
        <Flex direction="column">
          <BaseText>{{ $t('register.note_info') }}</BaseText>
          <BaseInput
            v-model="note"
            type="textarea"
            focus
            v-test="'create-note-input'"
          />
        </Flex>
      </BaseGrid>
    </BaseGrid>
    <template #footerSub>
      <BaseText
        v-if="currentNote"
        @click="deleteNote"
        color="error"
        v-test="'create-note-delete'"
      >
        {{ $t('global.actions.delete') }}
      </BaseText>
    </template>
    <template #footer>
      <BaseButton
        @click="submit"
        v-test="'create-note-save'"
      >
        {{ $t('global.actions.save') }}
      </BaseButton>
    </template>
  </BaseModal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    currentNote: {
      type: String,
      default: '',
    },
  },
  emits: ['submit', 'close'],
  data() {
    return {
      note: '',
    };
  },
  methods: {
    submit() {
      this.$emit('submit', this.note);
      this.$emit('close');
    },
    deleteNote() {
      this.note = null;
      this.submit();
    },
  },
  created() {
    this.note = this.currentNote;
  },
});
</script>
